import styled, { css } from 'styled-components'
import { tokens } from '@arvoreeducacao/bonsai-ds'

const { colors, fontWeights } = tokens

export const StyleButton = styled.button`
  ${({ bgColor, borderColor }) => css`
    background-color: ${bgColor || colors.white};
    border: 1px solid ${borderColor || colors.black2};
  `}
  width: 40px;
  height: 40px;
  border-radius: ${tokens.radius.xlarge};
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  position: relative;
  outline: none;

  &:focus-visible {
    outline: 2px solid ${colors.dark6};
    outline-offset: 2px;
  }
`

export const Notifications = styled.div`
  min-width: 16px;
  min-height: 16px;
  background-color: ${colors.red3};
  color: ${colors.white};
  border-radius: ${tokens.radius.xlarge};
  position: absolute;
  top: -4px;
  right: -4px;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: ${fontWeights.bold};
`
export const ImageIcon = styled.img`
  width: 18px;
  height: 18px;
`
